// ?????? console
if (process.env.NODE_ENV === 'production') {
    console.log = function () {};  // ?? console.log
    console.info = function () {};  // ?? console.info
    console.warn = function () {};  // ?? console.warn
    console.error = function () {};  // ?? console.error
}

import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import V3DragZoom from "v3-drag-zoom";
import "v3-drag-zoom/dist/style.css";

// ??????
window.__VUE_PROD_DEVTOOLS__ = false;
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;


const app = createApp(App);
app.use(ElementPlus);
app.use(V3DragZoom);
app.mount('#app');

